import { render, staticRenderFns } from "./InquiryCard.vue?vue&type=template&id=2a06e658"
import script from "./InquiryCard.vue?vue&type=script&lang=ts"
export * from "./InquiryCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports